module.exports = __webpack_public_path__ + "images/feature_post_bg.png";


//////////////////
// WEBPACK FOOTER
// ./images/feature_post_bg.png
// module id = 67
// module chunks = 0